module.exports = __webpack_public_path__ + "img/others.4a4b0386.svg";